import {THANAS} from '../../../../Config/ApiUrl'
import {axiosGet} from "../../../../Helpers/AxiosHelper";

export default {
    data() {
        return {
            options: {
                name: this.$t('police-stations'),
                url: THANAS,
                showHeader: true,
                tableShadow: false,
                columns: [
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',
                        isVisible: true
                    },
                    {
                        title: this.$t('district'),
                        type: 'custom-html',
                        key: 'district',
                        isVisible: true,
                        modifier: (district) => district?.name
                    },
                    {
                        title: 'Action',                    // Action type column
                        type: 'action',
                        key: 'invoice',
                        isVisible: true
                    },
                ],
                showFilter: true,
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('districts'),
                        "type": "drop-down-filter",
                        key: "districts",
                        option: [],
                        listValueField: 'name'
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'edit',
                        name: 'edit',
                        modifier: () => this.$can('update_police_stations')
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'demo-delete',
                        name: 'delete',
                        url: THANAS,
                        modifier: () => this.$can('delete_police_stations')
                    }
                ],
            }
        }
    },
    methods: {
        getDistricts() {
            axiosGet('select-able/districts').then(response => {
                this.options.filters.find(fl => fl.key === 'districts').option = response.data;
            })
        }
    },
    created() {
        this.getDistricts();
    }
}